import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CheckCircleIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7238 6.21432C10.2786 6.21432 5.86495 10.628 5.86495 16.0732C5.86495 21.5182 10.2786 25.932 15.7238 25.932C21.169 25.932 25.5826 21.5182 25.5826 16.0732C25.5826 10.628 21.169 6.21432 15.7238 6.21432ZM4.0188 16.0732C4.0188 9.60839 9.25902 4.36816 15.7238 4.36816C22.1885 4.36816 27.4288 9.60839 27.4288 16.0732C27.4288 22.5379 22.1885 27.7782 15.7238 27.7782C9.25902 27.7782 4.0188 22.5379 4.0188 16.0732Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9025 7.50067C28.1515 7.9455 27.9927 8.50799 27.5479 8.75702C21.8761 11.9321 18.3297 17.0869 16.6377 20.2653C16.4812 20.5594 16.1783 20.7464 15.8451 20.7544C15.512 20.7624 15.2004 20.5902 15.0299 20.3039C13.8944 18.3977 12.4541 16.7013 10.6974 15.2176C10.3079 14.8887 10.2588 14.3063 10.5877 13.9168C10.9167 13.5273 11.4991 13.4783 11.8886 13.8072C13.3888 15.0743 14.6823 16.4893 15.7704 18.049C17.7649 14.7128 21.309 10.1338 26.6461 7.14611C27.0909 6.89708 27.6535 7.05582 27.9025 7.50067Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default CheckCircleIcon;
